export const toDataSnakeCase = (data) =>
  Object.keys(data).reduce((acc, key) => {
    const newKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
    return { ...acc, [newKey]: data[key] };
  }, {});

export const mapProfileData = (inputProfileData) => {
  return {
    id: inputProfileData.id,
    username: inputProfileData.username || '',
    displayName: inputProfileData.display_name || '',
    email: inputProfileData.email || '',
    birthday: inputProfileData.birthday,
    streetAddress: inputProfileData.street_address || '',
    zipCode: inputProfileData.zip_code || '',
    city: inputProfileData.city,
    country: inputProfileData.country,
    gender: inputProfileData.gender || '',
    maritalStatus: inputProfileData.marital_status || '',
    educationalLevel: inputProfileData.educational_level,
    familyIncome: inputProfileData.family_income,
  };
};
